import React, { Suspense, useEffect, useState } from "react";
// material-ui
import { Box, Grid, Typography } from "@mui/material";

// project imports
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import ConfettiImage from "../../../../src/assets/images/confetti.png";
import useIntranetPortalCoreApi from "../../../hooks/useIntranetPortalAdminApi";
import {
  UserProfileService,
  type IntranetPortal_UserProfiles_Dtos_UserProfileDto
} from "../../../services/intranet-portal-services";
import { selectUser } from "../../utilities/auth/authSlice";
import ActiveAppCard from "./ActiveAppCard";
import Anniversary from "./Anniversary";
import BirthdayCelebration from "./BirthdayCeleb";
import EmployeeMood from "./EmployeeMood";
import LeaveCard from "./LeaveCard";
import { selectUserRole } from "../../utilities/auth/userRoleSlice";
import Calendar from "./Calendar";

// ==============================|| DEFAULT DASHBOARD ||============================== //

export const BirthCard = styled.div`
  padding: 10px 10px;
  background: white;
  display: flex;
  gap: 20px;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 0,
    rgba(212, 44, 44, 0.19) 100%
  );
  background-size: contain;
  background-position: right bottom;
  border-radius: 5px;
  margin-top: 5px;
  position: relative;
  &:before {
    content: "";

    background: url(${ConfettiImage}) no-repeat;
    background-size: contain;
    background-position: right bottom;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  &.cardView {
    margin-top: 0px;
    flex-direction: column;
    height: 400px;
    max-width: 400px;
    min-width: 400px;
    width: 100%;
    gap: 10px;
    text-align: center;
    background: linear-gradient(
      320deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 0,
      rgba(212, 44, 44, 0.19) 100%
    );
    &:before {
      background-size: 60%;
      transform: rotate(45deg) translate(50px, -100px);
    }
    .avatar {
      margin-inline: auto;
      margin-top: -50px;
      height: 80px;
      width: 80px;
    }
    .birthCard_content {
    }
    .user {
      flex-direction: column;
      text-align: center;
    }
    .designation {
      text-align: center;
    }
  }
  &.popUpCard {
    min-width: 380px;
    .avatar {
      margin-top: -50px;
      height: 80px;
      width: 80px;
    }
    .typing {
    }
  }
  .birthCard_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: relative;
  }
  .avatar {
    height: 40px;
    width: 40px;
    border-radius: 50%;
  }
  .user {
    font-size: 14px;
    font-weight: 500;
    color: #313131;
    display: flex;
    justify-content: space-between;
  }
  .date {
    font-weight: 400;
    color: #818181;
    font-size: 12px;
  }
  .designation {
    font-size: 12px;
    color: #818181;
  }
  .notify {
    display: inline-flex;
    font-size: 12px;
    border-radius: 14px;
    padding: 5px 8px;
    position: absolute;
    top: 50%;
    right: 0;
    color: #313131;
    font-weight: 500;
    background: #ffffffcc;
    z-index: 0;
    backdrop-filter: blur(2px);
    align-items: center;
    gap: 4px;
    transform: translateY(-50%);
    svg {
      font-size: 16px;
      color: #d42c2c;
    }
  }
`;

const Dashboard = (): React.ReactElement => {
  const [employeeDetails, setEmployeeDetails] =
    useState<IntranetPortal_UserProfiles_Dtos_UserProfileDto>();
  const [showModule, setShowModule] = useState<any>();

  const user = useSelector(selectUser);
  const userData = useSelector(selectUserRole);
  const id = user?.profile?.sub;

  useEffect(() => {
    if (userData !== null) {
      const data = userData?.userRole?.features?.values;
      setShowModule(data?.["IntranetPortal.CelebrationFeature"]);
    }
  }, [userData]);

  const { handleRequest } = useIntranetPortalCoreApi();

  const getEmployeeFullProfile = async (): Promise<void> => {
    await handleRequest(() =>
      UserProfileService.getCoreApiApiAppUserProfileUserProfileById(id)
    ).then((response) => {
      if (response != null) {
        setEmployeeDetails(response);
      }
    });
  };

  // const getApplicationConfiguration = async (): Promise<void> => {
  //   try {
  //     const response = await handleRequest(() =>
  //       AbpApplicationConfigurationService.getCoreApiApiAbpApplicationConfiguration()
  //     )
  //     if (response != null) {
  //       const data = response.features?.values
  //       setShowModule(data?.["IntranetPortal.CelebrationFeature"])
  //     }
  //   } catch (error) {}
  // }
  useEffect(() => {
    void getEmployeeFullProfile();
    // void getApplicationConfiguration()
  }, [id]);

  // usePageTracking()
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h4" sx={{ fontWeight: "500", mb: "1rem" }}>
            {/* <Icon color="primary" sx={{ mr: "8px" }}>
              <MdOutlineCake size="2rem" />
            </Icon> */}
            <Box component="span" style={{ color: "#d32c2c", fontWeight: 300 }}>
              Welcome,
            </Box>{" "}
            {`${(employeeDetails?.name as string) ?? ""} ${
              (employeeDetails?.middleName as string) ?? ""
            } ${(employeeDetails?.surName as string) ?? ""}`}
          </Typography>
        </Grid>
        <Grid item xs={12} lg={8}>
          {
            <Suspense fallback="isLoading...">
              <ActiveAppCard />
            </Suspense>
          }
          <Grid item>
            {
              <Suspense fallback="isLoading...">
                <LeaveCard />
              </Suspense>
            }
          </Grid>
          <Grid item xs={12}>
            {
              <Suspense fallback="isLoading...">
                <Calendar />
              </Suspense>
            }
          </Grid>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Grid item xs={12} sx={{ mb: 3 }}>
            {
              <Suspense fallback="isLoading...">
                <EmployeeMood />
              </Suspense>
            }
          </Grid>
          {showModule === "true" ? (
            <>
              <Grid item xs={12}>
                {
                  <Suspense fallback="isLoading...">
                    <BirthdayCelebration />
                  </Suspense>
                }
              </Grid>
              <Grid item xs={12}>
                {
                  <Suspense fallback="isLoading...">
                    <Anniversary />
                  </Suspense>
                }
              </Grid>
            </>
          ) : null}
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
